import { calculateLiquidationPrice as _calculateLiquidationPrice } from "@unlockdfinance/unlockd-math";

export const calculateLiquidationPrice = (
  debt: bigint,
  liquidationThreshold: bigint
): bigint => {
  return _calculateLiquidationPrice({ debt, liquidationThreshold }) as bigint;
};
